export default function Home() {
  return (
      <div className="homepage">

      </div>
    )
  }

  /*
  <img className="example" src="https://i.postimg.cc/xjvnSwnq/mx05abasr3s01.jpg" align="center" alt="treytheurkel"></img>
        <h3> Click the images below for the inside scoop! </h3>
        <a href="https://brave-glacier-00e751b0f.3.azurestaticapps.net/projects"> <img className="robot" src="https://i.postimg.cc/kGmTbr5M/IMG-0551.jpg" alt="robot"></img> </a>
        <a href="https://github.com/DrTreEsq?tab=repositories"> <img className="robot" src="https://i.postimg.cc/ydJFrB1P/IMG-1486.avif" alt="robot"></img> </a>
        <a href="https://brave-glacier-00e751b0f.3.azurestaticapps.net/services"> <img className="robot" src="https://i.postimg.cc/gjqVhnwr/d3871fb68bb5c11b3585aa3e61d6b7b3.jpg" alt="robot"></img> </a>
  */
